import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPlusLarge = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.5 10.5355H24V13.5355H13.5V24.0355H10.5V13.5355H0V10.5355H10.5V0.0354614H13.5V10.5355Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgPlusLarge);
const Memo = memo(ForwardRef);
export default Memo;
